module.exports = __webpack_public_path__ + "img/manage-active.9632da6b.svg";